import React from 'react';
import './scss/layout.scss';
import LayoutProp from './properties/layout';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';

function LayoutBlank({ title, className, children }: LayoutProp): React.ReactElement {
  let heading;
  if (title) {
    heading = <h1>{title}</h1>;
  } else {
    heading = '';
  }
  return (
    <div className={className} style={{ height: '100%' }}>
      <main>
        <div className="container-fluid">
          {heading}
          {children}
        </div>
      </main>
    </div>
  );
}

export default LayoutBlank;
